import styled from "styled-components";
export const LoaderContainer = styled.div`
  display: inline-block;
  align-self: center;
  margin-top: auto;
  margin-bottom: auto;
`;
